import fileDownload from 'js-file-download';

const BASE_URL = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3000/crear'
  : 'https://sideop-excel.hermosillo.gob.mx/crear';

const BASE_URL_MULTI = process.env.NODE_ENV !== 'production'
  ? 'http://localhost:3000/multi'
  : 'https://sideop-excel.hermosillo.gob.mx/multi';

export default {
  methods: {
    async mixGenerarExcel(data) {
      this.estaCargando = true;
      await this.axios.post(
        BASE_URL,
        data,
        { responseType: 'blob' },
      )
        .then((res) => {
          fileDownload(res.data, `${this.contrato?.numero ? this.contrato.numero : ''}${this.contrato?.numero ? '_' : ''}${this.nombreDocumento}.xlsx`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.estaCargando = false;
    },
    async mixGenerarExcelMultiPagina(data) {
      this.estaCargando = true;
      await this.axios.post(
        BASE_URL_MULTI,
        data,
        { responseType: 'blob' },
      )
        .then((res) => {
          fileDownload(res.data, `${this.contrato?.numero ? this.contrato.numero : ''}${this.contrato?.numero ? '_' : ''}${this.nombreDocumento}.xlsx`);
        })
        .catch((err) => {
          this.mixMensajeError(err.data.message);
        });
      this.estaCargando = false;
    },
  },
};
